export const Divider = ({size="medium"}) => (
    <div style={{
        width: "100%",
        height: size === "small"? "1px" : size === "medium"? "2px" : "3px",
        backgroundColor: "rgb(203, 208, 221)",
    }}/>
)
